'use strict';

define('vb/private/helpers/fragmentHelper',['vb/private/log'], (Log) => {
  /** @typedef {import('vb/private/stateManagement/container').default} Container */

  /** @type Object */
  const symbol = Symbol('fragment-helper');
  const logger = Log.getLogger('/vb/stateManagement/fragmentHelper', [
    // Register a custom logger
    {
      name: 'coralInfo',
      severity: 'info',
      style: 'coral',
    },
  ]);
  /**
   * Fragment Helper that provides methods to manage the state of a fragment, associated with a specific outer
   * container, identified by a stable and unique fragmentId.
   */
  class FragmentHelper {
    /**
     * Creates an instance of FragmentHelper.
     *
     * @param {Object} context - The context object that is hidden using a closure. See modelUtils.js.
     * @param {Container} context.container - An instance of a container, such as a page, fragment, or layout,
     *    which can hold one or more fragments. If a valid container is not provided, an error is logged.
     */
    constructor(context = { container: undefined }) {
      if (!context.container) {
        logger.error('Unable to create a FragmentHelper instance because a valid container was not provided!');
        return;
      }

      Object.defineProperty(this, symbol, {
        value: {
          container: context.container,
        },
      });
    }

    /**
     * Marks the fragment state for deletion.
     *
     * This method checks if a valid `fragmentId` is provided and, if so, it marks the state
     * of the fragment associated with the given `fragmentId` for deletion. If the `fragmentId`
     * is not provided, it logs a warning message.
     *
     * @param {String} fragmentId - The stable and unique identifier of the fragment to be marked for deletion.
     */
    deleteState(fragmentId) {
      if (!fragmentId) {
        logger.warn('Unable to delete fragment state because a fragment id was not provided!');
      } else {
        const oc = this[symbol].container;
        if (typeof oc.addFragmentForDispose === 'function') {
          oc.addFragmentForDispose(fragmentId);
        }
      }
    }
  }

  return FragmentHelper;
});

